export default __webpack_public_path__ + "static/rigor-603737bc1743420a43fe29d52c650e98.png";